<script>
import highlightedRestaurants from '@/modules/mixins/highlightedRestaurants'

export default {
    name: 'PopularRestaurants',
    mixins: [highlightedRestaurants],
    data() {
        return {
            type: 'popular',
        }
    },
}
</script>

<template lang="pug">
.popular-restaurants.min-w-50
    h2.d-flex.align-items-baseline.justify-content-between {{$t('restaurant.popular')}}
        router-link.font-size-m.d-inline-flex.align-items-center(:to="{name: 'popular-restaurant-list', query: $route.query}")
            | {{$t('base.see_all')}}
            icon.ml-3(icon="fa-solid fa-long-arrow-alt-right")
    swiper(:loaded="total")
        restaurant-card(
            v-for="(restaurant, index) in list"
            :delay="restaurants.delay"
            :key="`popular-${restaurant.id}-${index}`"
            :model="restaurant"
            carousel)

</template>
